import React, { useState } from "react";
import PropTypes from "prop-types";
import { Input } from "reactstrap";
import { FormGroup } from "reactstrap";
import Translate from "../../../hoc/Locale/Translate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
const LoginInputs = props => {
  const {
    email,
    password,
    inputChangedHandler,
    resetClientErrors,
    appLanguage
  } = props;

  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormGroup>
      <Input
        type={email.elementConfig.type}
        placeholder={appLanguage === "en" ? "E-Mail Address" : "E-Mail Adresse"}
        valid={email.valid}
        invalid={email.touched && email.valid === false}
        onChange={event => resetClientErrors(event, "email")}
        onBlur={event => inputChangedHandler(event, "email")}
        onFocus={e => (e.target.placeholder = "")}
      />
      {email.touched && email.valid === false && email.value !== "" && (
        <div className="invalid-feedback text-left">
          <Translate id="Auth.Login.Error.Email" />
        </div>
      )}
      {email.touched && email.valid === false && email.value === "" && (
        <div className="invalid-feedback text-left">
          <Translate id="Auth.Login.Error.Email.Empty" />
        </div>
      )}
      <br />

      <div style={{ position: "relative" }}>
        <Input
          type={showPassword ? "text" : "password"}
          placeholder={appLanguage === "en" ? "Password" : "Passwort"}
          valid={password.valid}
          invalid={password.touched && password.valid === false}
          onChange={event => resetClientErrors(event, "password")}
          onBlur={event => inputChangedHandler(event, "password")}
          onFocus={e => (e.target.placeholder = "")}
          style={{ paddingRight: "40px" }}
        />
        <button
          type="button"
          aria-label={
            showPassword
              ? appLanguage === "en" ? "Hide password" : "Passwort verbergen"
              : appLanguage === "en" ? "Show password" : "Passwort anzeigen"
          }
          aria-pressed={showPassword}
          onClick={() => setShowPassword(previous => !previous)}
          style={{
            position: "absolute",
            right: "10px",
            top: "50%",
            transform: "translateY(-50%)",
            border: 0,
            background: "transparent",
            padding: 0,
            cursor: "pointer"
          }}
        >
          <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
        </button>
      </div>

      {password.touched && password.valid === false && password.value !== "" && (
        <div className="invalid-feedback text-left">
          <Translate id="Auth.Login.Error.Passwort" />
        </div>
      )}
      {password.touched && password.valid === false && password.value === "" && (
        <div className="invalid-feedback text-left">
          <Translate id="Auth.Login.Error.Passwort.Empty" />
        </div>
      )}
    </FormGroup>
  );
};

LoginInputs.propTypes = {
  email: PropTypes.object,
  password: PropTypes.object,
  appLanguage: PropTypes.string,
  inputChangedHandler: PropTypes.func,
  resetClientErrors: PropTypes.func
};

export default LoginInputs;
